import { PwaInstall } from '@marque/ui'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './App'
import './index.css'

// Suppress spurious "message channel closed" unhandled rejections that originate
// from Chrome extension messaging (not from our app code). These fire when an
// extension listener returns `true` but the extension's background page closes
// before it can send a response — nothing we can do about it from page JS.
window.addEventListener('unhandledrejection', (event) => {
    const msg = event.reason instanceof Error
        ? event.reason.message
        : String(event.reason ?? '')
    if (msg.includes('message channel closed') || msg.includes('listener indicated an asynchronous response')) {
        event.preventDefault()
    }
})

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { retry: 1, staleTime: 30_000 },
    },
})

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <PwaInstall name="Marque Ops" />
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </StrictMode>,
)
